import { deleteCommercial, getCommercial, postFileCommercial } from "../index";
import {
  ApplicationAttachmentsDocument,
  AttachmentMetaDocument,
  AttachmentUploadConfigurationDocument,
  BasicAccountApplicationDocument,
  CardApplicationDocument,
  CompanyAttachment,
  PersonAttachment,
} from "../generated-types";

/**
 * This functions uploads the provided file to the backend.
 *
 * @param file The user provided File.
 * @param applicationRef The applications unique identifier.
 * @param attachmentDocumentType The document's type.
 */
const upload = (
  file: File,
  applicationRef:
    | BasicAccountApplicationDocument["applicationRef"]
    | CardApplicationDocument["applicationRef"],
  attachmentDocumentType:
    | CompanyAttachment["domain"]
    | PersonAttachment["domain"],
): Promise<AttachmentMetaDocument> => {
  const formData = new FormData();
  formData.append("file", file);

  // average estimate for 10MB upload on 3G (1.7mbit/s). Doubled on that to be safe.
  const averageThreeGUploadTime = 100;

  return postFileCommercial(
    `/protected/application/${applicationRef}/attachment/${attachmentDocumentType}`,
    formData,
    averageThreeGUploadTime,
  )
    .then((res) => Promise.resolve(res))
    .catch((e) => Promise.reject(e));
};

/**
 * This function gets all the needed settings for the attachments, like the max file size value.
 */
const properties = (): Promise<AttachmentUploadConfigurationDocument> => {
  return getCommercial("/protected/attachment/properties");
};

/**
 * This function gets the current state of the attachments from the backend.
 */
const sync = (): Promise<ApplicationAttachmentsDocument> => {
  return getCommercial(`/protected/application/attachment`)
    .then((res) => Promise.resolve(res))
    .catch((e) => Promise.reject(e));
};

/**
 * This function removes an attachment.
 *
 * @param uuid The attachments unique identifier.
 */
const remove = (
  applicationRef: string,
  uuid: AttachmentMetaDocument["uuid"],
): Promise<unknown> => {
  return deleteCommercial(
    `/protected/application/${applicationRef}/attachment/${uuid}`,
  )
    .then((res) => Promise.resolve(res))
    .catch((e) => Promise.reject(e));
};

export const UploadApi = {
  upload,
  properties,
  sync,
  remove,
};
